import React, { useEffect, useRef } from "react";

const ProgressBar = React.memo(function ProgressBar({
  progress,
  currentQuestion,
  sections,
}) {
  const fillRef = useRef(null);

  useEffect(() => {
    if (fillRef.current) {
      fillRef.current.style.width = `${progress}%`;
    }
  }, [progress]);

  if (sections.length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      {/* Percentage bar */}
      <div className="flex items-center gap-4">
        <div className="flex-1 h-1.5 rounded-full bg-white/10 overflow-hidden">
          <div ref={fillRef} className="spss-progress-bar-fill" />
        </div>
        <span className="text-white/60 font-sans text-xs font-semibold tabular-nums min-w-[3ch] text-right">
          {progress}%
        </span>
      </div>

      {/* Section indicators — derived from visible questions */}
      <div className="flex items-center gap-2 flex-wrap">
        {sections.map((section, idx) => {
          const isCurrentSection =
            currentQuestion && currentQuestion.section === section.name;

          return (
            <div key={section.name} className="flex items-center gap-2">
              {idx > 0 && (
                <div
                  className={`w-4 h-px transition-colors duration-500
                    ${isCurrentSection ? "bg-white/30" : "bg-white/10"}`}
                />
              )}
              <span
                className={`text-[10px] desktop:text-xs font-sans font-medium transition-all duration-500 px-2.5 py-1 rounded-full
                  ${
                    isCurrentSection
                      ? "bg-white/15 text-white"
                      : "text-white/40"
                  }`}
              >
                {section.name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default ProgressBar;
